(function() {
    var gallerySelector = '.product__photos--nh-gallery-ab-test';

    function initGridVideoAutoplay() {
      if (
        !window.matchMedia('(min-width: 769px)').matches ||
        !('IntersectionObserver' in window)
      ) {
        return;
      }

      var videos = document.querySelectorAll(
        gallerySelector + ' video.product__video[data-video-type="mp4"]:not([data-nh-grid-autoplay])'
      );

      if (!videos.length) {
        return;
      }

      var observer = new IntersectionObserver(function(entries) {
        entries.forEach(function(entry) {
          var video = entry.target;

          if (entry.isIntersecting) {
            if (video.muted && video.paused) {
              var playPromise = video.play();
              if (playPromise && typeof playPromise.catch === 'function') {
                playPromise.catch(function() {});
              }
            }
          } else if (!video.paused) {
            video.pause();
          }
        });
      }, {threshold: 0.25});

      videos.forEach(function(video) {
        video.setAttribute('data-nh-grid-autoplay', '');
        observer.observe(video);
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initGridVideoAutoplay);
    } else {
      initGridVideoAutoplay();
    }
    document.addEventListener('shopify:section:load', initGridVideoAutoplay);

    if (
      !window.theme ||
      !theme.Slideshow ||
      !theme.Photoswipe ||
      theme.Slideshow.prototype.nhPdpGalleryAbTestPatched
    ) {
      return;
    }
  
    theme.Slideshow.prototype.nhPdpGalleryAbTestPatched = true;
  
    function getGallery(slideshow) {
      if (!slideshow.args || !slideshow.args.childNav) {
        return null;
      }
  
      return slideshow.args.childNav.closest(gallerySelector);
    }
  
    function isMobileGallery(slideshow) {
      return getGallery(slideshow) && window.matchMedia('(max-width: 768px)').matches;
    }
  
    var originalInitChildNav = theme.Slideshow.prototype.initChildNav;
  
    theme.Slideshow.prototype.initChildNav = function() {
      originalInitChildNav.apply(this, arguments);
  
      var gallery = getGallery(this);
  
      if (
        !gallery ||
        !this.args.childNavScroller ||
        !window.matchMedia('(max-width: 768px)').matches
      ) {
        return;
      }
  
      requestAnimationFrame(function() {
        var mainPhotos = gallery.querySelector('.product__main-photos');
        var mainRect = mainPhotos ? mainPhotos.getBoundingClientRect() : {left: 0, right: 0, width: 0};
        var scrollerRect = this.args.childNavScroller.getBoundingClientRect();
        var thumbGap = parseFloat(
          getComputedStyle(this.args.childNavScroller).getPropertyValue('--nh-gallery-thumb-gap')
        ) || 6;
  
        if (mainRect.width > 0) {
          var thumbSize = (mainRect.width - (3 * thumbGap)) / 4;
          this.args.childNavScroller.style.setProperty('--nh-gallery-thumb-size', thumbSize + 'px');
          this.args.childNavScroller.style.setProperty(
            '--nh-gallery-edge-left',
            (mainRect.left - scrollerRect.left) + 'px'
          );
          this.args.childNavScroller.style.setProperty(
            '--nh-gallery-edge-right',
            (scrollerRect.right - mainRect.right) + 'px'
          );
        }
      }.bind(this));
    };
  
    var originalChildNavGoTo = theme.Slideshow.prototype.childNavGoTo;
  
    theme.Slideshow.prototype.childNavGoTo = function(index) {
      if (!isMobileGallery(this) || !this.args.childNavScroller) {
        return originalChildNavGoTo.apply(this, arguments);
      }
  
      var scroller = this.args.childNavScroller;
  
      this.args.childNavScroller = null;
      try {
        originalChildNavGoTo.apply(this, arguments);
      } finally {
        this.args.childNavScroller = scroller;
      }
  
      var link = this.childNavLinks[index];
      var thumbItem = link && link.closest('.product__thumb-item');
  
      if (!thumbItem) {
        return;
      }
  
      var centeredLeft = thumbItem.offsetLeft - ((scroller.clientWidth - thumbItem.offsetWidth) / 2);
      var maxScrollLeft = scroller.scrollWidth - scroller.clientWidth;
      var scrollBehavior = window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';
  
      scroller.scrollTo({
        left: Math.min(maxScrollLeft, Math.max(0, centeredLeft)),
        behavior: scrollBehavior
      });
    };
  
    function getGallerySlides(container) {
      return Array.prototype.filter.call(
        container.querySelectorAll('.product-main-slide'),
        function(slide) {
          return !slide.classList.contains('flickity-clone');
        }
      );
    }

    function buildImageItem(slide, image) {
      return {
        msrc: image.currentSrc || image.src,
        src: image.getAttribute('data-photoswipe-src'),
        w: image.getAttribute('data-photoswipe-width'),
        h: image.getAttribute('data-photoswipe-height'),
        el: image,
        nhSlide: slide
      };
    }

    // Preview image of a video slide, used for the lightbox thumbnail strip
    function getSlideImageSrc(slide) {
      var image = slide.querySelector('img');

      return image ? (image.currentSrc || image.src) : '';
    }

    function isolatePlayerEvents(holder) {
      ['pointerdown', 'pointerup', 'mousedown', 'mouseup', 'touchstart', 'touchend', 'click', 'dblclick'].forEach(function(type) {
        holder.addEventListener(type, function(evt) {
          evt.stopPropagation();
        });
      });
    }

    function buildMp4Item(slide, video) {
      var holder = document.createElement('div');
      holder.className = 'nh-pswp-video';
      isolatePlayerEvents(holder);

      var player = document.createElement('video');
      player.className = 'nh-pswp-video__player';
      player.setAttribute('playsinline', '');
      player.setAttribute('controls', '');
      player.setAttribute('controlsList', 'nodownload');
      player.setAttribute('preload', 'metadata');
      player.muted = true;
      player.loop = video.loop;

      var aspectRatio = parseFloat(video.getAttribute('data-aspect-ratio'));
      if (!aspectRatio && video.videoWidth && video.videoHeight) {
        aspectRatio = video.videoWidth / video.videoHeight;
      }
      if (aspectRatio > 0) {
        player.style.setProperty('--nh-pswp-video-ratio', aspectRatio);
        player.classList.add('nh-pswp-video__player--sized');
      }

      if (video.getAttribute('poster')) {
        player.setAttribute('poster', video.getAttribute('poster'));
      }

      video.querySelectorAll('source').forEach(function(source) {
        var copy = document.createElement('source');
        copy.src = source.getAttribute('src');
        if (source.getAttribute('type')) {
          copy.type = source.getAttribute('type');
        }
        player.appendChild(copy);
      });

      holder.appendChild(player);

      return {
        html: holder,
        el: video.closest('.product__video-wrapper') || slide,
        nhSlide: slide,
        nhThumb: video.getAttribute('poster') || getSlideImageSrc(slide),
        nhVideo: player
      };
    }

    function buildEmbedItem(slide, embed) {
      var type = embed.getAttribute('data-video-type');
      var id = embed.getAttribute('data-video-id');
      var src = '';

      if (type === 'youtube') {
        src = 'https://www.youtube.com/embed/' + id + '?rel=0&playsinline=1';
      } else if (type === 'vimeo') {
        src = 'https://player.vimeo.com/video/' + id;
      }

      if (!src || !id) {
        return null;
      }

      var holder = document.createElement('div');
      holder.className = 'nh-pswp-video';
      isolatePlayerEvents(holder);

      var frame = document.createElement('iframe');
      frame.className = 'nh-pswp-video__player';
      frame.src = src;
      frame.setAttribute('allow', 'autoplay; fullscreen; picture-in-picture');
      frame.setAttribute('allowfullscreen', '');
      frame.setAttribute('frameborder', '0');
      holder.appendChild(frame);

      return {
        html: holder,
        el: embed.closest('.product__video-wrapper') || slide,
        nhSlide: slide,
        nhThumb: getSlideImageSrc(slide),
        nhFrame: frame
      };
    }

    function getGalleryItems(container) {
      var items = [];

      getGallerySlides(container).forEach(function(slide) {
        var mp4 = slide.querySelector('video.product__video[data-video-type="mp4"]');
        var embed = slide.querySelector('.product__video[data-video-type="youtube"], .product__video[data-video-type="vimeo"]');
        var imageWrap = slide.querySelector('.image-wrap');
        var image = imageWrap && !imageWrap.classList.contains('hide')
          ? imageWrap.querySelector('.photoswipe__image')
          : null;
        var item = null;

        if (mp4) {
          item = buildMp4Item(slide, mp4);
        } else if (embed) {
          item = buildEmbedItem(slide, embed);
        } else if (image) {
          item = buildImageItem(slide, image);
        }

        if (item) {
          items.push(item);
        }
      });

      return items;
    }

    function getClickedGalleryIndex(items, trigger) {
      var clickedSlide = trigger.closest('.product-main-slide');

      return items.findIndex(function(item) {
        return item.nhSlide === clickedSlide;
      });
    }

    function pauseLightboxMedia(items, exceptItem) {
      items.forEach(function(item) {
        if (item === exceptItem) {
          return;
        }

        if (item.nhVideo && !item.nhVideo.paused) {
          item.nhVideo.pause();
        }

        if (item.nhFrame && item.nhFrame.parentNode) {
          item.nhFrame.src = item.nhFrame.src;
        }
      });
    }

    function playLightboxVideo(item) {
      if (!item || !item.nhVideo || !item.nhVideo.paused) {
        return;
      }

      var playPromise = item.nhVideo.play();
      if (playPromise && typeof playPromise.catch === 'function') {
        playPromise.catch(function() {});
      }
    }

    function silencePageVideo(slide) {
      var video = slide && slide.querySelector('video.product__video');

      if (!video) {
        return;
      }

      video.pause();
      video.muted = true;

      if (theme.Product && theme.Product.prototype.syncVideoSoundToggle) {
        theme.Product.prototype.syncVideoSoundToggle(video);
      }
    }

    function resumeVisiblePageVideos(container) {
      container.querySelectorAll('video.product__video').forEach(function(video) {
        var rect = video.getBoundingClientRect();
        var inView = rect.width > 0 && rect.bottom > 0 && rect.top < window.innerHeight;

        if (inView && video.muted && video.paused) {
          var playPromise = video.play();
          if (playPromise && typeof playPromise.catch === 'function') {
            playPromise.catch(function() {});
          }
        }
      });
    }

    function openClickedGalleryImage(trigger) {
      var container = trigger.closest('[data-product-images]');

      if (!container || container.dataset.zoom === 'false') {
        return;
      }

      var photoswipe = Object.create(theme.Photoswipe.prototype);
      photoswipe.container = container;
      photoswipe.sectionId = '';
      photoswipe.inSlideshow = container.dataset.hasSlideshow === 'true';
      photoswipe.items = getGalleryItems(container);

      if (!photoswipe.items.length) {
        return;
      }

      var clickedIndex = getClickedGalleryIndex(photoswipe.items, trigger);
      var originalAfterChange = photoswipe.afterChange;
      var pendingSync = false;

      photoswipe.afterChange = function() {
        var current = this.gallery.currItem;

        pauseLightboxMedia(this.items, current);

        if (isPageHiddenBehindLightbox()) {
          pendingSync = true;
        } else {
          originalAfterChange.apply(this, arguments);
        }

        if (current && (current.nhVideo || current.nhFrame)) {
          silencePageVideo(current.nhSlide);
          playLightboxVideo(current);
        }
      };

      photoswipe.initGallery(photoswipe.items, clickedIndex >= 0 ? clickedIndex + 1 : 1);

      photoswipe.gallery.listen('destroy', function() {
        var current = photoswipe.gallery.currItem;

        pauseLightboxMedia(photoswipe.items, null);

        if (pendingSync) {
          pendingSync = false;
          originalAfterChange.call(photoswipe);
        }

        if (current && (current.nhVideo || current.nhFrame)) {
          silencePageVideo(current.nhSlide);
        }

        resumeVisiblePageVideos(container);
      });
    }

    function isPageHiddenBehindLightbox() {
      return document.documentElement.classList.contains('pswp-open-in-ios');
    }

    var originalPhotoswipeTriggerClick = theme.Photoswipe.prototype.triggerClick;

    theme.Photoswipe.prototype.triggerClick = function(evt) {
      if (!evt.currentTarget.closest(gallerySelector)) {
        return originalPhotoswipeTriggerClick.apply(this, arguments);
      }

      openClickedGalleryImage(evt.currentTarget);
    };

    document.addEventListener('click', function(evt) {
      var trigger = evt.target.closest('.js-photoswipe__zoom');

      if (!trigger || !trigger.closest(gallerySelector)) {
        return;
      }

      evt.preventDefault();
      evt.stopImmediatePropagation();
      openClickedGalleryImage(trigger);
    }, true);
  })();
  